"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAuthRequestStatus = exports.getTacAuthRequestDetailByTrxId = exports.getTacAuthRequestDetail = void 0;
const configurations_1 = require("@/data-manager/configurations");
const requestUtil_1 = require("@/data-manager/requestUtil");
const getTacAuthRequestDetail = (data, headers) => {
    const url = (0, configurations_1.getServer)().MS_UI_TOKEN_MANAGEMENT + configurations_1.PATH.AUTH_REQUEST_DETAIL.replace(/\{\w*}/, data);
    return (0, requestUtil_1.fetchRequest)(url, 'GET', data, headers);
};
exports.getTacAuthRequestDetail = getTacAuthRequestDetail;
const getTacAuthRequestDetailByTrxId = (data, headers) => {
    const url = (0, configurations_1.getServer)().MS_UI_TOKEN_MANAGEMENT + configurations_1.PATH.AUTH_REQUEST_DETAIL_TRX_ID.replace(/\{\w*}/, data);
    return (0, requestUtil_1.fetchRequest)(url, 'GET', data, headers);
};
exports.getTacAuthRequestDetailByTrxId = getTacAuthRequestDetailByTrxId;
const verifyAuthRequestStatus = (data, headers) => {
    const url = (0, configurations_1.getServer)().MS_UI_TOKEN_MANAGEMENT + configurations_1.PATH.VERIFY_AUTH_REQUEST_STATUS.replace(/\{\w*}/, data);
    return (0, requestUtil_1.fetchRequest)(url, 'GET', data, headers);
};
exports.verifyAuthRequestStatus = verifyAuthRequestStatus;
